/**
 * Absolute paths for the Compliance Reviews section's tab routes.
 *
 * These are the paths components navigate to and match against, the router's
 * three `compliance-reviews*` route records, `ComplianceReview.vue` /
 * `ComplianceSignOff.vue`'s post-action redirect, and the three list tables'
 * `route-prefix` all import from here — so a tab's path, its `isRouteActive`
 * check, the `route-prefix` its list table pushes to and its route
 * registration are one string rather than four copies that fail silently when
 * one is mistyped. Nothing type-checks a route path, and there is no test
 * runner here, so a mismatch surfaces only as a tab that stops highlighting or
 * a row click that lands on the not-found page.
 */
export const REVIEWS_PATH = '/compliance-reviews'
export const SIGN_OFF_PATH = '/compliance-reviews/sign-off'
export const CERTIFICATION_PATH = '/compliance-reviews/certification'

/**
 * Base path of the Annual Process section (SMCR-328). Unlike the three above it
 * is not a tab of this section — it is a section of its own with its own
 * sub-tabs (SMCR-333/334), and it lives here only because it is nested under
 * `REVIEWS_PATH` and so has to stay in step with it.
 *
 * Spelled out rather than a bare `ANNUAL_PATH` because `sidebar-config.ts`
 * imports this alongside `/annual-certification` — two different "annual" paths
 * in one file, and this is the name that reads unambiguously at the call site.
 */
export const ANNUAL_REVIEWS_PATH = '/compliance-reviews/annual'

/** Annual Process's own Sign Off sub-tab. */
export const ANNUAL_SIGN_OFF_PATH = '/compliance-reviews/annual/sign-off'

/**
 * Base path of the Regulatory References section (SMCR-315) — Compliance's step 2 queue/form for
 * the Leaver Regulatory Reference workflow. Named `COMPLIANCE_REGULATORY_REFERENCES_PATH`, not the
 * shorter `REGULATORY_REFERENCES_PATH`, because that name is already taken by
 * `@/pages/regulatory-references/routes`'s export — a different "Regulatory References" section
 * (under "Initiate Process") that `sidebar-config.ts` also imports, so the two names must not
 * collide. Same reasoning `HR_REGULATORY_REFERENCES_PATH` was given on the HR side (`SMCR-314`).
 */
export const COMPLIANCE_REGULATORY_REFERENCES_PATH = '/compliance-reviews/regulatory-references'
